import { Injectable } from '@angular/core';
import {AbstractMapService} from "./abstract-map.service";
import {AppConfigService} from "../../config/app-config.service";
import {MessageService} from "../../messages/message.service";
import {TranslateService} from "../../shared/translate.service";
import {UserPositionService} from "./user-position.service";

@Injectable({
  providedIn: 'root'
})
export class BingMapsMobileService extends AbstractMapService{


  constructor(protected config: AppConfigService,
              protected messageService: MessageService,
              protected translateService: TranslateService,
              protected userPositionService: UserPositionService) {
    super(config, messageService, translateService, userPositionService);
  }


  protected createMapObject(mapId: HTMLElement): Microsoft.Maps.Map {

    let map = new Microsoft.Maps.Map(mapId, {
      credentials: this.bingApiKey,
      enableCORS: true,
      liteMode: true,
      navigationBarMode: Microsoft.Maps.NavigationBarMode.compact,
      disableScrollWheelZoom: true,
      showMapTypeSelector: false,
      enableClickableLogo: false,
      customMapStyle: {
        'version': '1.0',
        elements: {
          road: {labelOutlineColor: 'white', labelColor: 'black'},
          forest: {visible: false},
          park: {visible: false}
        }
      }
    });
    Microsoft.Maps.Events
      .addHandler(map, 'viewchangeend', () => this.emitCurrentMapLocalization(map));
    return map;
  }
}
